<template>
  <div class="auth-wrapper auth-v2">
    <b-row class="auth-inner m-0">
      <!-- Brand logo-->
      <b-link class="brand-logo">
        <b-img
          :src="require('@/assets/images/logo/secondary-logo.png')"
          class="rounded mr-2"
          height="30"
          width="150"
          alt="Toast image"
        />
      </b-link>
      <!-- /Brand logo-->
      <!-- Left Text-->
      <b-col lg="8" class="d-none d-lg-flex align-items-center p-5">
        <div
          class="w-100 d-lg-flex align-items-center justify-content-center px-5"
        >
          <b-img fluid :src="imgUrl" alt="Login V2" />
        </div>
      </b-col>
      <!-- /Left Text-->

      <!-- Login-->
      <b-col lg="4" class="d-flex align-items-center auth-bg px-2 p-lg-5">
        <!-- Recaptcha -->
        <b-form-group v-if="isFirstLogin && recaptcha === null">
          <validation-provider
            #default="{ errors }"
            name="recaptcha"
            vid="recaptcha"
            rules="required"
          >
            <vue-recaptcha
              ref="recaptcha"
              v-model="recaptcha"
              :sitekey="siteKey"
              @verify="mxVerify"
            />
            <small class="text-danger">{{ errors[0] }}</small>
          </validation-provider>
        </b-form-group>
        <b-col
          v-if="!isFirstLogin || recaptcha !== null"
          sm="8"
          md="6"
          lg="12"
          class="px-xl-2 mx-auto"
        >
          <b-card-title class="mb-1 font-weight-bold" title-tag="h2">
            Reset Your Password
          </b-card-title>
          <b-card-text class="mb-2">
            Please reset your password that you remember.
          </b-card-text>
          <!-- form -->
          <validation-observer
            ref="accountRules"
            tag="form"
            #default="{ invalid }"
          >
            <b-form class="auth-login-form mt-2" @submit.prevent="onSubmit">
              <!-- password -->
              <b-form-group label="Old Password" label-for="old-password">
                <validation-provider
                  #default="{ errors }"
                  name="oldPassword"
                  vid="oldPassword"
                  rules="required"
                >
                  <b-input-group
                    class="input-group-merge"
                    :class="errors.length > 0 ? 'is-invalid' : null"
                  >
                    <b-form-input
                      id="login-password"
                      v-model="requestData.oldPassword"
                      :state="errors.length > 0 ? false : null"
                      class="form-control-merge"
                      :type="passwordFieldType"
                      name="login-password"
                      placeholder="Old Password"
                    />
                    <b-input-group-append is-text>
                      <feather-icon
                        class="cursor-pointer"
                        :icon="passwordToggleIcon"
                        @click="togglePasswordVisibility"
                      />
                    </b-input-group-append>
                  </b-input-group>
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
              <b-form-group label="New Password" label-for="reset-password">
                <validation-provider
                  #default="{ errors }"
                  rules="required"
                  vid="Password"
                  name="newPasword"
                >
                  <b-input-group
                    class="input-group-merge"
                    :class="errors.length > 0 ? 'is-invalid' : null"
                  >
                    <b-form-input
                      id="login-password"
                      v-model="requestData.newPassword"
                      :state="errors.length > 0 ? false : null"
                      class="form-control-merge"
                      :type="passwordFieldType"
                      name="login-password"
                      placeholder="New Password"
                    />
                    <b-input-group-append is-text>
                      <feather-icon
                        class="cursor-pointer"
                        :icon="passwordToggleIcon"
                        @click="togglePasswordVisibility"
                      />
                    </b-input-group-append>
                  </b-input-group>
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>

              <b-form-group
                label="Confirm Password"
                label-for="confirm-reset-password"
              >
                <validation-provider
                  #default="{ errors }"
                  name="confirm Password"
                  vid="confirm Password"
                  rules="required|confirmed:Password"
                >
                  <b-input-group
                    class="input-group-merge"
                    :class="errors.length > 0 ? 'is-invalid' : null"
                  >
                    <b-form-input
                      id="confirm-password"
                      v-model="requestData.confirmPassword"
                      :state="errors.length > 0 ? false : null"
                      class="form-control-merge"
                      :type="passwordFieldType"
                      name="confirm-password"
                      placeholder="Confirm Password"
                    />
                    <b-input-group-append is-text>
                      <feather-icon
                        class="cursor-pointer"
                        :icon="passwordToggleIcon"
                        @click="togglePasswordVisibility"
                      />
                    </b-input-group-append>
                  </b-input-group>
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
                <p v-if="!isCorrect" class="text-danger">
                  Confirm password must match with new password.
                </p>
                <p v-if="!isLengthCorrect" class="text-danger">
                  Invalid pasword. Password length should be minimum of 5 digit.
                </p>
              </b-form-group>

              <!-- submit buttons -->
              <b-button
                type="submit"
                variant="primary"
                block
                :disabled="invalid"
              >
                Reset Password
              </b-button>
            </b-form>
          </validation-observer>
        </b-col>
      </b-col>

      <!-- loadings -->
      <b-overlay :show="isLoading" no-wrap rounded="sm" />
    </b-row>
  </div>
</template>

<script>
/* eslint-disable global-require */
import { ValidationProvider, ValidationObserver } from "vee-validate";
import {
  BRow,
  BCol,
  BLink,
  BFormGroup,
  BFormInput,
  BInputGroupAppend,
  BInputGroup,
  BOverlay,
  BFormCheckbox,
  BCardText,
  BCardTitle,
  BImg,
  BForm,
  BButton,
  BFormGr,
} from "bootstrap-vue";
import { VueRecaptcha } from "vue-recaptcha";
import { required, email } from "@validations";
import { togglePasswordVisibility } from "@core/mixins/ui/forms";
import store from "@/store/index";
// import { getHomeRouteForLoggedInUser } from '@/auth/utils'
import useJwt from "@/auth/jwt/useJwt";
import axios from "@axios";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import { initialAbility } from "@/libs/acl/config";
export default {
  components: {
    BRow,
    BCol,
    BLink,
    BFormGroup,
    BFormInput,
    BInputGroupAppend,
    BInputGroup,
    BFormCheckbox,
    BCardText,
    BCardTitle,
    BImg,
    BForm,
    BButton,
    BOverlay,
    ValidationProvider,
    ValidationObserver,
    VueRecaptcha,
  },

  mixins: [togglePasswordVisibility],

  data() {
    return {
      SERVICE_KEY: process.env.VUE_APP_SERVICE_KEY,
      siteKey: "6Len0LgpAAAAALQJmv8fyVHggHy8s5On5muoJSs6",
      isCorrect: true,
      isLengthCorrect: true,
      isLoading: false,
      recaptcha: null,
      isFirstLogin: this.$route.params.isFirstLogin,
      requestData: {
        username: this.$route.params.id,
        oldPassword: "",
        newPassword: "",
      },
      isForgotPassword: false,
      status: "",
      sideImg: require("@/assets/images/pages/new-banner.svg"),
      // validation rules
      required,
      email,
    };
  },

  computed: {
    passwordToggleIcon() {
      return this.passwordFieldType === "password" ? "EyeIcon" : "EyeOffIcon";
    },
    imgUrl() {
      if (store.state.appConfig.layout.skin === "dark") {
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
        this.sideImg = require("@/assets/images/pages/new-banner.svg");
        // this.sideImg = require('@/assets/images/pages/login-v2-dark.svg')
        return this.sideImg;
      }
      return this.sideImg;
    },
  },
  methods: {
    mxVerify(response) {
      if (response) {
        this.recaptcha = response;
      }
      this.recaptcha = response;
    },
    onSubmit() {
      this.$refs.accountRules.validate().then((success) => {
        if (success) {
          this.isLoading = true;
          axios
            .post("/User/api/V1.0/Password/ChangePassword", this.requestData)
            .then((res) => {
              if (res.status) {
                this.isLoading = false;
                // Reset ability
                this.$ability.update(initialAbility);
                this.$toast({
                  component: ToastificationContent,
                  position: "top-right",
                  props: {
                    title: "Success",
                    icon: "BellIcon",
                    variant: "Success",
                    text: `Password Changed Successfully`,
                  },
                });
                // Redirect to login page
                this.$router.push({ name: "auth-login" });
              }
            })
            .catch((res) => {
              this.isLoading = false;
              console.log(res);
              console.log(res.data.errors);
              if (res.status === 400) {
                this.$toast({
                  component: ToastificationContent,
                  position: "top-right",
                  props: {
                    title: "Error",
                    icon: "BellIcon",
                    variant: "danger",
                    text: `${res.data.errors.NewPassword}`,
                  },
                });
              } else if (res.status === 500) {
                this.$toast({
                  component: ToastificationContent,
                  position: "top-right",
                  props: {
                    title: "Error",
                    icon: "BellIcon",
                    variant: "danger",
                    text: `${res.data.message}`,
                  },
                });
              }
            });
        } else {
          reject();
        }
      });
    },
  },
};
</script>
<style lang="scss">
@import "@core/scss/vue/pages/page-auth.scss";
</style>
